<template>
    <div class="phone-input">
        <vue-phone-number-input
            ref="vuePhoneNumberInput"
            v-model="currentPhone.number"
            class="inner-flex"
            size="lg"
            :translations="translations"
            :default-country-code="currentPhone.code"
            :color="ChartConfig.color.primary"
            :only-countries="onlyCountries"
            :no-validator-state="true"
            :show-code-on-list="true"
            :class="{ 'number-error': numberError, 'ignore-dialog': typeof dialog != 'undefined', mobile: $bp.smallScreen }"
            :required="typeof isRequired != 'undefined' ? isRequired : true"
            :no-example="currentPhone.is_valid"
            @update="updateCurrentPhone"
        ></vue-phone-number-input>
        <v-flex class="v-messages phone-input-messages pt-2 pb-0">
            <div class="v-messages__wrapper" :class="numberError ? 'error--text' : 'd-none'">
                <div class="v-messages__message">
                    {{ errorMessage ? errorMessage : $t("lang.required") }}
                </div>
            </div>
        </v-flex>
        <v-text-field
            ref="validPhoneNumber"
            :key="updatePhoneInput"
            v-model="updateObject[modelName]"
            class="d-none"
            :rules="rules"
            type="number"
        ></v-text-field>
    </div>
</template>

<script>
// WEBSITE THAT CONTAINS INVALID AREA CODES IN ORDER TO HELP DURING TESTING
// 'https://www.areacodehelp.com/where/unassigned-area-codes.shtml'
import VuePhoneNumberInput from "vue-phone-number-input";
import { mapGetters } from "vuex";

export default {
    props: ["updateObject", "rules", "inputName", "dialog", "errorMessage", "inputLabel", "phone_number", "code", "isRequired"],
    components: { VuePhoneNumberInput },
    computed: {
        ...mapGetters(["ChartConfig", "onlyCountries"]),
        modelName() {
            return this.inputName ? this.inputName : "phone_number";
        },
        numberError() {
            return (
                this.rules &&
                this.rules.length > 0 &&
                !this.currentPhone.is_valid &&
                this.$refs.validPhoneNumber != undefined &&
                !this.$refs.validPhoneNumber.valid
            );
        },
        translations() {
            return {
                countrySelectorLabel: this.$t("lang.countrySelectorLabel"),
                countrySelectorError: this.$t("lang.countrySelectorError"),
                phoneNumberLabel:
                    this.inputLabel && this.$t(`lang.${this.inputLabel}`) != `lang.${this.inputLabel}`
                        ? this.$t(`lang.${this.inputLabel}`)
                        : this.$t("lang.phoneNumberLabel"), // applies label if set with prop
                example: this.$t("lang.example"),
            };
        },
    },
    data() {
        return {
            currentPhone: {
                number: null,
                code: "US",
                is_valid: false,
            },
            updatePhoneInput: 0,
        };
    },
    methods: {
        async updateCurrentPhone(phone) {
            var updatePhone = {};
            if (phone && phone.phone_number && phone.code) {
                // if manually updating
                this.$nextTick(() => {
                    var props = this.$refs.vuePhoneNumberInput.getParsePhoneNumberFromString({ phoneNumber: this.phone_number, countryCode: this.code });
                    updatePhone = {
                        phone_number_formatted: props.formatNational && props.isValid ? props.formatNational : "",
                        phone_number: props.formatNational && props.isValid ? props.nationalNumber : "",
                        code: props.countryCode,
                    };
                    this.currentPhone = {
                        // since manual, update local
                        number: props.formatNational,
                        code: props.countryCode,
                        is_valid: props.isValid,
                    };
                });
            } else if (
                typeof phone !== "undefined" &&
                phone &&
                ((typeof phone.nationalNumber !== "undefined" && phone.nationalNumber) || phone.phoneNumber || phone.countryCode)
            ) {
                // if component's @update triggers
                this.currentPhone.code = phone.countryCode;
                this.currentPhone.is_valid = phone.isValid;
                updatePhone = {
                    phone_number_formatted: phone.formatNational && phone.isValid ? phone.formatNational : "",
                    phone_number: phone.formatNational && phone.isValid ? phone.nationalNumber : "",
                    code: phone.countryCode,
                };
            } else {
                // if manually resetting
                this.$nextTick(() => {
                    updatePhone = {
                        phone_number_formatted: null,
                        phone_number: null,
                        code: "US",
                    };
                    this.currentPhone = {
                        // since manual, update local
                        number: null,
                        code: "US",
                        is_valid: false,
                    };
                });
            }

            this.$nextTick(() => {
                this.updatePhoneInput++;
                this.updateObject[`${this.modelName}_formatted`] = updatePhone.phone_number_formatted;
                this.updateObject[this.modelName] = updatePhone.phone_number;
                this.updateObject["country_iso_2"] = updatePhone.code;
            });
        },
        formatPhone(phone) {
            let props = this.$refs.vuePhoneNumberInput.getParsePhoneNumberFromString({ phoneNumber: phone.phone_number, countryCode: phone.country_iso_2 });
            return props.formatNational;
        },
    },
};
</script>
